import { createFileRoute } from '@tanstack/react-router';
import DocsGroupLayout from '@/components/Docs/DocsGroupLayout';

export const Route = createFileRoute('/developers')({
  component: DevelopersLayout,
});

function DevelopersLayout() {
  return <DocsGroupLayout group="developers" />;
}
